import ContactsFormPanel from './ContactsFormPanel';

export default ContactsFormPanel;


// WEBPACK FOOTER //
// ./src/components/forms/ContactsFormPanel/index.js